import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { TextField } from '@mui/material';
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const TimePicker = (props) => {
	const { value, onChange, label, style, ...rest } = props;

	const [open, setOpen] = useState(false);
	const [currentValue, setCurrentValue] = useState(value);

	const defaultSx = { width: '100%', backgroundColor: 'white' };

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<MuiTimePicker
				open={open}
				onOpen={() => setOpen(true)}
				onClose={() => setOpen(false)}
				renderInput={(p) => (
					<TextField
						{...p}
						fullWidth
						onClick={(e) => setOpen(true)}
						onChange={e => {
							setCurrentValue(e.target.value);
						}}
						onBlur={e => { 
							onChange(currentValue);
						 }}
					/>
				)}
				slotProps={{
					textField: {
						onBlur: e => { 
							if (moment(currentValue).isValid())
								onChange(currentValue);
						 }}
					}
				}
				inputVariant="outlined"
				value={!currentValue ? null : moment(currentValue)}
				onChange={(newValue) => {
					setCurrentValue(newValue);
				}} // to disable warning)}
				label={label}
				ampm={false}
				sx={style ? style : defaultSx}
				{...rest}
			/>
		</LocalizationProvider>
	);
};

TimePicker.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
	label: PropTypes.func,
	errorText: PropTypes.string,
	isKeyboardTimePicker: PropTypes.bool
};

export default TimePicker;
